export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    alignItems?: "start" | "end" | "center";
    justifyContent?: "start" | "end" | "center" | "between" | "around";
    className?: string;
}

export function HBox({
    children,
    alignItems,
    justifyContent,
    className,
    ...rest
}: Props) {
    const justify = justifyContent ? `justify-content-${justifyContent}` : "";
    const align = alignItems
        ? `align-items-${alignItems}`
        : "align-items-center";
    const klass = className || "";

    return (
        <div className={`d-flex ${justify} ${align} ${klass} `} {...rest}>
            {children}
        </div>
    );
}
